import { Light } from './Light.js';
import { DirectionalLight as BABYLON_DirectionalLight } from '@inter-ikea-betrakta-babylonjs/core/Lights/directionalLight.js';
import { Vector3 as BABYLON_Vector3 } from '@inter-ikea-betrakta-babylonjs/core/Maths/math.vector.js';
import { TrackedVec3 } from '../../../../Math.js';
import { IVector3, LightType } from '../../../../api.js';
import { DirectionalLightShadowController } from '../shadows/DirectionalLightShadowController.js';
import { DirectionalLightVisualizer } from '../debug_visualizers/DirectionalLightVisualizer.js';
export class DirectionalLight extends Light {
    constructor(viewer, position = { x: 0, y: 0, z: 0 }, target = { x: 0, y: 0, z: 0 }) {
        super(viewer);
        this._target = new TrackedVec3();
        this.type = LightType.DIRECTIONAL_LIGHT;
        const { x, y, z } = this.get_direction(position, target);
        this._babylon_light = new BABYLON_DirectionalLight(`Light_${this.id} (DirectionalLight)`, new BABYLON_Vector3(-x, -y, -z), this._viewer.scene);
        this.shadow = new DirectionalLightShadowController(this, this._babylon_light, this._light_system);
        this._target.onchange = () => this.mark_dirty(DirectionalLight.DIRTY_TARGET);
        this.position = position;
        this._target.set(target.x, target.y, target.z);
    }
    get target() {
        return this._target;
    }
    set target(value) {
        this._target.set(value.x, value.y, value.z);
    }
    get_direction(position = this.position, target = this._target) {
        return IVector3.normalize(IVector3.subtract(target, position));
    }
    update() {
        this.update_color_and_intensity();
        if (this.is_dirty(Light.DIRTY_POSITION)) {
            this._babylon_light.position.set(this.position.x, this.position.y, this.position.z);
            this.mark_dirty(DirectionalLight.DIRTY_TARGET);
        }
        if (this.is_dirty(DirectionalLight.DIRTY_TARGET)) {
            const { x, y, z } = this.get_direction();
            this._babylon_light.direction.set(x, y, z);
            this.mark_dirty(Light.DIRTY_SHADOW_MAP);
        }
    }
    set_intensity_lux(lux) {
        this._babylon_light.intensityMode = BABYLON_DirectionalLight.INTENSITYMODE_ILLUMINANCE;
        this.intensity = lux;
    }
    set parent(_) {
        console.warn(`Not able to set parent for light ${this._babylon_light.name}. DirectionalLights do not support parenting`);
    }
    create_debug_geometry() {
        const { line_manager, light_system, scene } = this._viewer;
        this._debug_geometry = new DirectionalLightVisualizer(this, line_manager, light_system.debug_color_mode, scene);
    }
}
DirectionalLight.DIRTY_TARGET = 16777216;
//# sourceMappingURL=DirectionalLight.js.map